export default  {
    Price: 'Price',
    Number: 'Number',
    Int: 'Int',
    Percent: 'Percent',
    PercentInt: 'PercentInt'
}
